"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

var _chartUtils = require("../../chartUtils");

var _colors = require("../../constants/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HoverBody = function HoverBody(_ref) {
  var crosshairCoordinateValues = _ref.crosshairCoordinateValues,
      hasBattery = _ref.hasBattery,
      timeZone = _ref.timeZone;
  var x = crosshairCoordinateValues.x,
      site = crosshairCoordinateValues.site,
      peer = crosshairCoordinateValues.peer,
      peerV2 = crosshairCoordinateValues.peerV2,
      contract = crosshairCoordinateValues.contract;
  var contractedPercentDiff = (0, _chartUtils.getFulfillmentPercentDiff)(site, contract);
  var peerPercentDiff = (0, _chartUtils.getFulfillmentPercentDiff)(site, peer);
  var peerV2PercentDiff = (0, _chartUtils.getFulfillmentPercentDiff)(site, peerV2);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.CrosshairDate, {
    dateMillis: x,
    timeZone: timeZone
  }), !(0, _lodash.isNil)(site) && (hasBattery ? /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.METER
  }, "System Production ".concat((0, _chartUtils.getFormattedValue)(parseFloat(site), 0), " kWh")) : /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverAreaKey, {
    stroke: _colors.SOLAR,
    fill: _colors.SOLAR_OPAQUE
  }, "Solar ".concat((0, _chartUtils.getFormattedValue)(parseFloat(site), 0), " kWh"))), !(0, _lodash.isNil)(peerV2) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.PEER_V2
  }, "Peer Adj: ".concat((0, _chartUtils.getFormattedValue)(parseFloat(peerV2), 0), " kWh"), peerPercentDiff && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLegendPercent, null, " (".concat(peerV2PercentDiff, "%)"))), !(0, _lodash.isNil)(peer) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.PEER_ADJ
  }, "Legacy Peer: ".concat((0, _chartUtils.getFormattedValue)(parseFloat(peer), 0), " kWh"), peerPercentDiff && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLegendPercent, null, " (".concat(peerPercentDiff, "%)"))), !(0, _lodash.isNil)(contract) && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.CONTRACTED
  }, "Contracted: ".concat((0, _chartUtils.getFormattedValue)(parseFloat(contract), 0), " kWh"), contractedPercentDiff && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLegendPercent, null, " (".concat(contractedPercentDiff, "%)"))));
};

HoverBody.propTypes = {
  crosshairCoordinateValues: _propTypes["default"].shape({
    contract: _propTypes["default"].number,
    peer: _propTypes["default"].number,
    peerV2: _propTypes["default"].number,
    site: _propTypes["default"].number,
    x: _propTypes["default"].number.isRequired
  }).isRequired,
  hasBattery: _propTypes["default"].bool.isRequired,
  timeZone: _propTypes["default"].string.isRequired
};
var _default = HoverBody;
exports["default"] = _default;